import React from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Title } from "./components/Title";

export const ContactPage = () => {

    const contactAction = async (event) => {
        event.preventDefault();

        const formData = new FormData(event.target);

        try {
            const res = await fetch(event.target.action, {
            method: "POST",
            body: formData, // bez headers!
            });

            const formMessages = document.querySelector("div#form-messages");

            // find submit button and disable it
            const submitButton = event.target.querySelector("button[type='submit']");
            submitButton.disabled = true;
            submitButton.textContent = "Sending...";
            event.target.classList.add("disabled");

            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            const data = await res.json(); // obavezno await
            console.log("Server response:", data);

            formMessages.textContent = data.message;
            formMessages.className = data.alert + " mb-4";

            // write message
            setTimeout(() => {
                formMessages.textContent = "";
                formMessages.className = "";
            }, 9000);
            

        } catch (err) {
            console.error("Fetch error:", err);
        }
        finally {
            // re-enable button
            const submitButton = event.target.querySelector("button[type='submit']");
            submitButton.disabled = false;
            submitButton.textContent = "Pošalji Upit";
            event.target.classList.remove("disabled");

            event.target.reset();
        }
    };

    return (
        <>
        <Header />
        <Title title="Kontakt" />
        <main>
           
           <div className="contact-area-wrapper tmp-section-gap">
            {/* <!-- Tpm Get In touch start --> */}
            <section className="get-in-touch-area">
                <div className="container">
                    <div className="contact-get-in-touch-wrap">
                        <div className="get-in-touch-wrapper tmponhover">
                            <div className="row g-5 align-items-center">
                                <div className="col-lg-5">
                                    <div className="section-head text-align-left">
                                        <div className="section-sub-title tmp-scroll-trigger tmp-fade-in animation-order-1">
                                            <span className="subtitle">Besplatne konsultacije</span>
                                        </div>
                                        <h2 className="title split-collab tmp-scroll-trigger tmp-fade-in animation-order-2">Kako radimo sa upitima </h2>
                                        <p className="description tmp-scroll-trigger tmp-fade-in animation-order-3">Svaki zahtev prolazi kroz kratku analizu projekta. Kontaktiraćemo vas sa dodatnim pitanjima kako bismo definisali funkcionalnosti, sadržaj i budžet.</p>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="contact-inner">
                                        <div className="contact-form">
                                            <div id="form-messages" className="error"></div>
                                            <form onSubmit={contactAction} className="tmp-dynamic-form" id="contact--form" method="POST" action="https://izrada-web-sajta-cena.com/inc/form.php">

                                                <input type="hidden" id="template-contactform-botcheck" name="template-contactform-botcheck" value="" className="form-control" />
                                                <input type="hidden" name="prefix" value="template-contactform-"/>
                                                <div className="contact-form-wrapper row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <input className="input-field" name="name" id="contact-name" placeholder="Ime i prezime" type="text" required />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <input className="input-field" id="contact-phone" name="phone" placeholder="Broj telefona" type="tel" />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <input className="input-field" id="contact-email" name="email" placeholder="E-mail" type="email" required />
                                                        </div>
                                                    </div>

                                                    {/* <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <input className="input-field" type="text" id="subject" name="subject" placeholder="Subject" />
                                                        </div>
                                                    </div> */}

                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <textarea className="input-field" placeholder="Vaša poruka" name="poruka" id="contact-message" required></textarea>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-12">
                                                        <div className="tmp-button-here">
                                                            <button className="tmp-btn hover-icon-reverse radius-round w-100" name="submit" type="submit" id="submit">
                                                                <span className="icon-reverse-wrapper">
                                                                <span className="btn-text">Pošalji upit</span>
                                                                <span className="btn-icon"><i className="fa-sharp fa-regular fa-arrow-right"></i></span>
                                                                <span className="btn-icon"><i className="fa-sharp fa-regular fa-arrow-right"></i></span>
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Tpm Get In touch End --> */}
            </div>

        </main>
        <Footer />
        </>
    );
}